<template>
    <v-dialog :value="dialog" max-width="500px" persistent scrollable :fullscreen="ehMobile">
        <v-card class="co-novo-papel" :disabled="loading">
            <v-card-title class="title primary--text">
                <span v-if="ehNovoPapel">Novo Papel</span>
                <span v-else>Editar Papel</span>
                <v-spacer/>
                <v-icon color="primary" @click="fechar"> mdi-window-close </v-icon>
            </v-card-title>

            <form @submit.prevent="salvar" class="mx-3" data-vv-scope="form-novo-papel">
                <v-card-text class="campos pt-0">
                    <v-text-field
                        v-model="organizacaoPapel.nome"
                        v-validate="'required'"
                        class="required-field"
                        :error-messages="errors.collect('nome', 'form-novo-papel')"
                        label="Nome"
                        name="nome"
                    />
                </v-card-text>

                <v-divider/>
                <v-card-actions class="mx-3 my-2">
                    <v-btn class="cancelar" depressed outlined @click="fechar">
                        CANCELAR
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" type="submit" depressed :loading="loading">
                        SALVAR
                    </v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
import {actionTypes} from '@/commons/constants'

export default {
    name: 'DialogNovoPapel',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        organizacaoPapel: {
            type: Object,
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ehNovoPapel() {
            return this.organizacaoPapel.id === null
        },
        ehMobile() {
            return this.$vuetify.breakpoint.xs
        }
    },
    methods: {
        async criarPapel() {
            try {
                this.loading = true
                this.setMensagemLoading('Criando o papel...')

                await this.$store.dispatch(actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.CRIAR, {
                    nome: this.organizacaoPapel.nome
                })

                this.mostrarNotificacaoSucessoDefault()
                this.$emit('salvar')
            } finally {
                this.loading = false
            }
        },
        fechar() {
            this.$emit('fechar')
        },
        async salvar() {
            const formValido = await this.$validator._base.validateAll('form-novo-papel')

            if (!formValido) return

            if (this.ehNovoPapel) {
                await this.criarPapel()
            } else {
                await this.salvarEdicaoPapel()
            }
        },
        async salvarEdicaoPapel() {
            try {
                this.loading = true
                this.setMensagemLoading('Salvando alteração...')

                await this.$store.dispatch(actionTypes.ORGANIZACAO_PAPEL_SIGNATARIO.EDITAR, {
                    papelId: this.organizacaoPapel.id,
                    payload: {
                        nome: this.organizacaoPapel.nome,
                        ativo: this.organizacaoPapel.ativo
                    }
                })

                this.mostrarNotificacaoSucessoDefault()
                this.$emit('salvar')
            } catch {
                this.fechar()
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="stylus">
.co-novo-papel
    background-color: var(--background-100)
    height 100%
    overflow-y auto

    .cancelar
        color var(--text-color-200)

</style>
